module.exports = __webpack_public_path__ + "static/media/SuggestTopic.512b65e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/SHS-SPRINT/SuggestTopic.jpg
// module id = 3742
// module chunks = 0